import "../_components/_vendors/clickStream/clickstreamInit"
import "../_components/_vendors/lazysizes.min.js"
import "../_components/lazyLoaded/lazyLoaded.js"
import "../_components/_vendors/md5.js";
import Message from "../_components/messages/Message.js";

// 3rd party Vendors
import "../_components/_vendors/intercom/intercomInit.js";
import "../_components/_vendors/activeCampaign/activeCampaignSiteTracking.js";

import "../_components/_services/dismissableElementsService.js";
import "../_components/_services/collaterateNotifications.js"
import "../_components/_services/orderNotifications/needs-print-files-count.v1.directive.js"
import "../_components/_services/orderNotifications/needs-print-files-list.v1.directive.js"
import "../_components/_services/orderNotifications/pending-review-count.v1.directive.js"
import "../_components/_services/orderNotifications/pending-review-list.v1.directive.js"
import "../_components/_services/orderNotifications/requires-action-count.v1.directive.js"
import "../_components/_services/orderNotifications/requires-action-list.v1.directive.js"
import "../_components/_services/orderNotifications/total-notification-count.v1.directive.js"

Collaterate.Messages.subscribe(message => new Message(message));